import { defer, filter, finalize, Observable, Subject } from 'rxjs';
import { WritableSignal } from '@angular/core';

export function notNull<T>(): (source: Observable<T>) => Observable<T> {
  return (source: Observable<T>): Observable<T> => source.pipe(filter(x => x !== null && x !== undefined));
}

export function indicate<T>(indicator: Subject<boolean>): (source: Observable<T>) => Observable<T> {
  return (source: Observable<T>): Observable<T> =>
    source.pipe(
      prepare(() => indicator.next(true)),
      finalize(() => indicator.next(false)),
    );
}

export function indicateSignal<T>(indicator: WritableSignal<boolean>): (source: Observable<T>) => Observable<T> {
  return (source: Observable<T>): Observable<T> =>
    source.pipe(
      prepare(() => indicator.set(true)),
      finalize(() => indicator.set(false)),
    );
}

export function prepare<T>(callback: () => void): (source: Observable<T>) => Observable<T> {
  return (source$: Observable<T>): Observable<T> =>
    defer(() => {
      callback();
      return source$;
    });
}
